import {REQUEST_CALCULATED_BILLING_SUCCESS} from "../../../constant/transaction/CalculatedBillingConstant";

const initialState = {
    calculatedBilling: {
        data: [],
    },
};


export const calculatedBillingReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_CALCULATED_BILLING_SUCCESS:
            return {
                ...state,
                calculatedBilling: {
                    data: payload,
                },
            };
        default:
            return state;
    }
}
